import VxeLoadingComponent from './src/loading';
export var VxeLoading = Object.assign(VxeLoadingComponent, {
    install: function (app) {
        app.component(VxeLoadingComponent.name, VxeLoadingComponent);
    }
});
export var Loading = VxeLoading;
export default VxeLoading;
